import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { CAPSULE_IMAGE } from "@/lib/constants";

export const Capsule = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);
  const rot = useTransform(scrollYProgress, [0, 1], [2, -2]);

  return (
    <section id="capsule" ref={ref} className="border-y border-white/10 bg-rest-surface" data-testid="capsule-section">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 py-28 md:grid-cols-2 md:px-10 md:py-40 lg:gap-20">
        <motion.div
          style={{ rotate: rot }}
          className="relative order-2 overflow-hidden border border-white/10 md:order-1"
        >
          <motion.img
            style={{ y: imgY }}
            src={CAPSULE_IMAGE}
            alt="The Infinity Capsule — REST Recovery's newest recovery technology"
            loading="lazy"
            className="h-[420px] w-full scale-110 object-cover md:h-[560px]"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
          <span className="absolute left-5 top-5 border border-rest-blue/60 bg-black/60 px-3 py-1.5 font-mono text-[10px] uppercase tracking-[0.25em] text-rest-blue backdrop-blur-md" data-testid="capsule-new-badge">
            New technology
          </span>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="order-1 flex flex-col justify-center md:order-2"
        >
          <p className="mb-4 font-mono text-xs uppercase tracking-[0.25em] text-rest-blue">Introducing</p>
          <h2 className="font-display text-4xl font-black uppercase tracking-tighter md:text-6xl">
            The Infinity<br />Capsule
          </h2>
          <p className="mt-8 max-w-md text-base leading-relaxed text-zinc-400 md:text-lg">
            The first of its kind in North Phoenix. The Infinity Capsule layers next-generation recovery technology into a
            single immersive session — an experience you won't find anywhere else in Arizona.
          </p>
          <p className="mt-6 max-w-md text-sm leading-relaxed text-zinc-500">
            It's not a pitch. It's what our floor is becoming. Ask about the Capsule during your complimentary Recovery
            Experience — you'll be among the first in Arizona to see it.
          </p>
          <div className="mt-10">
            <a
              href="#offer"
              data-testid="capsule-cta-offer"
              className="inline-flex items-center gap-3 border border-white/20 px-7 py-4 font-mono text-xs uppercase tracking-[0.2em] text-white transition-colors duration-300 hover:border-rest-blue hover:text-rest-blue"
            >
              Claim my free session
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
